// extracted by extract-css-chunks-webpack-plugin
module.exports = {"DragBar":"DragBar_1LfcZ_v13-0-0"};
    if(module.hot) {
      // 1588357788473
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  